/**
 * 그룹웨어 편집기에 붙여넣기.
 *
 * 대표는 지금 엑셀에서 표를 복사해 메일에 붙여 넣는다. 그래서 초안도 **서식이 있는
 * 표**로 복사돼야 한다 — 평문만 넣으면 편집기에서 탭으로 늘어선 글자가 되고,
 * 그건 지금보다 나빠지는 것이다.
 *
 * `text/html` 과 `text/plain` 을 함께 넣는다. 편집기는 HTML 을, 메모장은 평문을 받는다.
 * 조용히 실패하지 않는다 — 못 복사하면 이유를 던진다 (SOUL S1).
 */
export async function copyRichText(html: string, text: string): Promise<void> {
  const clipboard = navigator.clipboard as
    | (Clipboard & { write?: (items: ClipboardItem[]) => Promise<void> })
    | undefined;

  if (clipboard?.write && typeof ClipboardItem !== "undefined") {
    await clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([text], { type: "text/plain" }),
      }),
    ]);
    return;
  }

  // 서식 없는 복사라도 되게 한다. 안 되면 이유를 말한다
  if (clipboard?.writeText) {
    await clipboard.writeText(text);
    return;
  }

  throw new Error(
    "이 브라우저에서는 클립보드에 쓸 수 없습니다. 아래 본문을 직접 선택해 복사해 주세요.",
  );
}
